import React from 'react'
import { useLanguage } from '../context/LanguageContext'
import { translations } from '../translations/translations'

export const T = ({ k }) => {
  const { language } = useLanguage()

  if (!k) return null

  // Get the translation or fallback to the key
  const translated = translations[language][k] || k

  return <>{translated}</>
}
